/**
 *  Do not use this to unsure that component exists. Compiler will still evaluate it
 * ```
 *  const obj: { a?: \{b?: number\}\} = \{ a: undefined \};
 *
 * // 🛑 This will throw an error
 * <Show if={obj.a?.b}>{obj.a!.b}</Show>
 *
 * // ✅ This will not throw an error
 * <Show if={obj.a?.b}>{obj.a?.b}</Show>
 * ```
 */
export const Show = ({
  if: _if,
  children
}: {
  if: unknown;
  children: React.ReactNode;
}) => (_if ? children : null);
